import axios from "axios";
import { backend_url } from "../../constants"; // Assuming your backend URL is stored here
import { AXIOS_CONFIG } from "../api";
import type { ResourceData } from "../../types/resources";

const API_URL = `${backend_url}/api/resources/`;

/**
 * Fetch LearnWorlds data for a user.
 *
 * @returns The LearnWorlds SSO URL or relevant data.
 */
export const fetchLearnWorldsData = async (): Promise<ResourceData> => {
  try {
    const response = await axios.get(`${API_URL}learn-worlds/sso`, {
      ...AXIOS_CONFIG,
      withCredentials: true, // Ensure cookies are sent with the request
    });

    return response.data.content;
  } catch (error) {
    console.error(`Error fetching LearnWorlds SSO data: ${error}`);
    throw error;
  }
};

/**
 * Fetch all webinar data from the backend.
 *
 * @returns The webinar data.
 */
export const fetchAllWebinarData = async (): Promise<any> => {
  try {
    const response = await axios.get(`${API_URL}zoom/`, {
      ...AXIOS_CONFIG,
    });
    return response.data.content;
  } catch (error) {
    console.error(`Error fetching webinar data: ${error}`);
    throw error;
  }
};

/**
 * Fetch all recordings for a given webinar event type.
 *
 * @param eventType - The type of event ('taxTuesday' or 'wildWednesday').
 * @returns The list of recordings for the specified event.
 */
export const fetchWebinarRecordings = async (): Promise<any> => {
  try {
    const response = await axios.get(`${API_URL}zoom/recordings`, {
      ...AXIOS_CONFIG,
    });
    return response?.data?.content;
  } catch (error) {
    console.error(`Error fetching webinar recordings: ${error}`);
    throw error;
  }
};
